<template>
  <a-form-model ref="AccountDetailForm" :model="form" :rules="rules">
    <a-form-model-item label="Project Currency" prop="project_currency">
      <a-select
        showSearch
        class="select-between"
        placeholder="Please Select"
        v-model="form.project_currency"
        @change="handleCurrency"
        :disabled="dataProcessed.InvoiceDetail.length == 0 ? false:true "
      >
        <a-select-option
          v-for="item in getMasterSC.project_currency"
          :key="item.value"
        >
          {{ item.text }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item label="Bank Account" prop="bank_account">
      <a-select
        showSearch
        class="select-between"
        placeholder="Please Select"
        allowClear
        v-model="form.bank_account"
      >
        <a-select-option
          v-for="item in bank_account"
          :key="item.value"
        >
          {{ item.text }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <div>
      <a-form-model-item prop="exchange_rate">
        <span slot="label">
          Exchange Rate 1.00
          {{ form.project_currency ? form.project_currency : "IDR" }} to IDR
        </span>
        <a-input-number
          :disabled="form.project_currency == 'IDR'"
          :min="0"
          class="m-width-full m-text-align right"
          :formatter="
            (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          "
          :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
          v-model="form.exchange_rate"
        />
      </a-form-model-item>
    </div>
    <a-form-model-item label="Project Value" prop="project_value">
      <a-input-number
        :min="0"
        class="m-width-full m-text-align right"
        :formatter="
          (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        "
        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
        v-model="form.project_value"
      />
    </a-form-model-item>
    <a-row :gutter="24">
      <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
        <a-form-model-item label="PPN" prop="ppn">
          <a-radio-group v-model="form.ppn" button-style="solid">
            <a-radio-button value="1"> Include </a-radio-button>
            <a-radio-button value="0"> Exclude </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
        <a-form-model-item label="PPN Value" prop="ppn_value">
          <a-input-number
            :min="0.1"
            class="m-width-full m-text-align right"
            :formatter="
              (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            v-model="form.ppn_value"
          />
        </a-form-model-item>
      </a-col>
    </a-row>
  </a-form-model>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
export default {
  name: "Account-Detail",
  props: {
    dataProcessed: {},
    mode: String,
  },
  data() {
    let minValue = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error("Value Cannot less than 0"));
      } else {
        callback();
      }
    };
    return {
      form: {
        bank_account: this.dataProcessed.AccountDetail.bank_account,
        project_currency: this.dataProcessed.AccountDetail.project_currency,
        exchange_rate: this.dataProcessed.AccountDetail.exchange_rate
          ? this.dataProcessed.AccountDetail.exchange_rate
          : 0,
        project_value: this.dataProcessed.AccountDetail.project_currency
          ? this.dataProcessed.AccountDetail.project_value
          : 0,
        ppn: this.dataProcessed.AccountDetail.ppn
          ? this.dataProcessed.AccountDetail.ppn
          : undefined,
        ppn_value: this.dataProcessed.AccountDetail.ppn_value
          ? this.dataProcessed.AccountDetail.ppn_value
          : 11,
      },
      rules: {
        ppn: [
          {
            required: true,
            message: "Please select PPN",
            trigger: "change",
          },
        ],
        bank_account: [
          {
            required: false,
          },
        ],
        project_currency: [
          {
            required: true,
            message: "Please select project currency",
            trigger: "change",
          },
        ],
        exchange_rate: [
          {
            required: true,
            trigger: "change",
            validator: minValue,
          },
        ],
        project_value: [
          {
            required: true,
            trigger: "change",
            validator: minValue,
          },
        ],
        ppn_value: [
          {
            required: true,
            message: "Please Input PPN Value",
            trigger: "change",
          },
        ],
      },
      bank_account: []
    };
  },
  mounted(){
    if(this.mode=='Edit')
      this.bank_account = _.filter(this.getMasterSC.bank_account, 
      { currency: this.dataProcessed.AccountDetail.project_currency });
  },
  computed: {
    ...mapGetters(["getMasterSC"]),
  },
  methods: {
    handleCurrency(item){
      // if (item == 'IDR'){
      //   this.form.exchange_rate = 1
      // }else{
      //   this.form.exchange_rate = 0
      // }
      this.form.exchange_rate = 1
      this.bank_account = _.filter(this.getMasterSC.bank_account, { currency: item });
      this.form.bank_account = undefined;
    },
    handleRef() {
      this.$refs.AccountDetailForm.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        Event.$emit("dataProcessed", this.form);
      });
    },
  },
};
</script>

<style></style>
